export enum OnPremAssetStatus {
    Active = 1,
    Deprecated = 2
}

export const mapToOnPremAssetStatus = (status: number): OnPremAssetStatus => {
    if (!isOnPremAssetStatus(status)) {
        throw new Error("Wrong asset status");
    }

    return status;
};

const isOnPremAssetStatus = (status: number): status is OnPremAssetStatus => {
    return Object.values(OnPremAssetStatus).includes(status);
};
